const DAY_LABELS: Record<string, string> = {
	mon: 'Mo',
	tue: 'Di',
	wed: 'Mi',
	thu: 'Do',
	fri: 'Fr',
	sat: 'Sa',
	sun: 'So',
}

const DAY_ORDER = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']

export type HoursMap = Record<string, Array<{ start: string; end: string }>> | null | undefined

/** Short snippet for cards, e.g. "Mo–Fr 10–18 · Sa 10–15" */
export const formatHoursSnippet = (hours: HoursMap): string => {
	if (!hours || typeof hours !== 'object') return 'Öffnungszeiten siehe Profil'
	const parts: string[] = []
	for (const day of DAY_ORDER) {
		const slots = hours[day]
		if (!slots?.length) continue
		const range = slots.map(s => `${s.start}–${s.end}`).join(', ')
		parts.push(`${DAY_LABELS[day]} ${range}`)
	}
	if (!parts.length) return 'Geschlossen'
	if (parts.length > 3) return `${parts.slice(0, 2).join(' · ')} …`
	return parts.join(' · ')
}

export const formatHoursList = (hours: HoursMap): Array<{ day: string; text: string }> => {
	if (!hours || typeof hours !== 'object') return []
	return DAY_ORDER.map(day => {
		const slots = hours[day]
		const text = !slots?.length
			? 'Geschlossen'
			: slots.map(s => `${s.start} – ${s.end}`).join(', ')
		return { day: DAY_LABELS[day] || day, text }
	})
}
